import UploadHubModalAdd from 'components/UploadHub/UploadHubModalAdd';
import { useEffect, useRef, useState } from 'react';
import useUploadFiles from 'api/hooks/useUploadFiles';
import { SkeletonContent } from 'components/WritingAssistant/ui/MyContent';
import type { UploadHubListItem } from 'api/services/uploadFileService';
import UploadHubItem from 'components/UploadHub/UploadHubItem';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from 'components/Login/Loading';

const UploadHub = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [files, setFiles] = useState<UploadHubListItem[]>([]);
  const { getUploadHubList } = useUploadFiles();
  const { addMetaTags } = useAddMetaTags();

  const fetchFiles = useRef<((signal: AbortSignal) => Promise<void>) | null>(null);
  fetchFiles.current = async (signal) => {
    try {
      const results = await getUploadHubList({ signal });
      if (results) {
        setFiles(results);
        const title = `Your files - PolicyMogul`;
        addMetaTags({ title, hash: location.hash });
        setIsLoading(false);
      }
    } catch {
      //Already use toaster
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchFiles.current?.(controller.signal);
    return () => controller.abort('Files list cancelled.');
  }, []);

  return (
    <>
      <div className={`bg-white monitor-items-bar`}>
        <div className='mx-auto main-content-wrapper flex-centered justify-content-between resize-elements-container'>
          <div className='side-left-element pl-md-5 pl-3 d-none d-lg-inline-block'>
            <p className={`mb-0 title-h4 nowrap-item monitor-dropdown-item`}>Files</p>
          </div>
          <div className='main-content flex-centered position-relative filters-general-container justify-content-end pr-xl-5 px-md-4 px-3'>
            <button
              className='general-button action-button specific-x-padding-15 rounded-pill'
              onClick={() => setIsOpen(true)}
            >
              <span className='icon-upload specific-left-margin-3 specific-right-margin-10 d-inline-block-centered paragraph-p4'></span>
              Upload a new file
            </button>
          </div>
        </div>
      </div>
      <div className={`row mx-auto main-content-wrapper align-items-start flex-grow-1 pt-5`}>
        <div className='w-100 px-xl-5 px-md-4 px-3 h-100 mx-auto'>
          <h3 className='title-h4-bold mb-3'>{"My team's files"}</h3>
          <div className='box-top-rounded h-100 p-lg-5 p-3'>
            {isLoading ? (
              <SkeletonContent />
            ) : files.length > 0 ? (
              <ul className='policy-list px-0 items-list upload-hub-list'>
                {files.map((file) => (
                  <UploadHubItem key={`item-${file.id}`} file={file} />
                ))}
              </ul>
            ) : (
              <p className='text-center mt-5 pt-5 title-h4 main-light-text px-5 mt-5 pt-lg-5'>
                Files you upload will appear here
              </p>
            )}
          </div>
        </div>
      </div>
      <UploadHubModalAdd filesState={{ listFiles: files, setListFiles: setFiles }} openState={{ isOpen, setIsOpen }} />
    </>
  );
};

export default withAuthenticationRequired(UploadHub, {
  onRedirecting: () => <Loading />,
});
